import { rules, patternType } from "@/common/tender/rules";
import { hooks } from "@/common/tender/hooks";

export const tenderProjectConfig = {
  TRADING_PLATFORM: "随行易交易电子招标投标交易平台",
  TRADING_PLATFORM_ADDRESS: "https://www.enjoy5191.com/",
  CUSTOMER_SERVICE_PHONE: "4008705191",
  /* 后端计算时需额外传的字段 （后缀加_CALC） */
  CALC_KEY: {
    施工: ["CONTROL_PRICE", "COMPETITION_PRICE", "NON_COMPETITION_PRICE"],
    设备采购: ["CONTROL_PRICE", "COMPETITION_PRICE", "NON_COMPETITION_PRICE"],
    材料采购: ["CONTROL_PRICE", "COMPETITION_PRICE", "NON_COMPETITION_PRICE"],
    勘察设计: ["CONTROL_PRICE", "COMPETITION_PRICE", "NON_COMPETITION_PRICE"],
    监理: ["CONTROL_PRICE", "COMPETITION_PRICE", "NON_COMPETITION_PRICE"],
  },
  CACL_KEY_FUNC(type, form) {
    this.CALC_KEY[type].forEach((key) => {
      if (form[key] != "") {
        form[key + "_CALC"] = {
          $numberDecimal: form[key],
        };
        form["updateContent_price"][key + "_CALC"] = {
          $numberDecimal: form[key],
        };
      } else {
        delete form[key + "_CALC"];
        delete form["updateContent_price"][key + "_CALC"];
      }
    });
    return form;
  },
  BZJ_ADDRESS: [
    "政和县",
    "松溪县",
    "光泽县",
    "永定区",
    "福清市",
    "南安市",
    "自主招标",
    "福建省国资采购平台",
    "场外福清市",
    '福建省国资采购平台(福清)',
    '福州市仓山区',
    "场外龙岩市",
    "尤溪数智招标采购平台",
    "厦门航空",
    '思明区小额招采平台'
  ], // 保证金地区
  CUSTOM_BANK_ACCOUNT: ["其他账户"], // 需要代理自定义填写保证金银行相关信息
  NO_DOC_PRICE_ADDRESS: ["3505", "350421", "x00007", "x00008", "350000"], // 标书费0元备案地区：泉州地区【3505】，福建省【350000】，明溪县 小型水利（莆田市）【x00007】  小型水利（城厢区）【x00008】 宁化县【350424】
  NO_DOC_PRICE_TRADE_CENTER: ["350000", "350783"], // 交易中心：福建省【350000】 建瓯 【350783】 宁化县【350424】
  INSIDE_NEED_DOC_PRICE_ADDRESS: [] /*场内标（除宁化）设置标书费默认为0元，置灰不可修改*/,
  CTBA_AREA: [
    "x00004",
    "x30001",
    "x30002",
    "x50002",
    "x60004",
    "x60005",
    "x350203",
  ] /*开启中招协的地区 自主招标、公E采、火炬集团，厦门航空 场外福清 福建省国资采购平台(不推送省平台) 海南招协特殊处理 思明区小额招采平台*/,
  initSelectKeys: [
    "select_IS_REBID",
    "select_IS_REPORT",
    "select_IsMultiSegment",
    "select_IS_REPORT_PROVINCE",
    "select_RELATE_CODE",
    "select_IS_MUST_BIDDING_BY_LAW",
    "select_TENDERER_PROPERTY",
    "select_PRICE_FORM_CODE",
    "select_QUALIFICATION_LEVEL",
    "select_IS_NOTARIZED",
    "select_NOTARY_OFFICE",
    "select_IS_OPEN_INVITATION_COMPANY",
    "select_OPEN_BID_SITE",
  ],
  OPEN_BID_SITE: [
    /*场外开标场地*/
    {
      value: "1",
      label: "其他场地",
    },
    {
      value: "2",
      label: "随行易交易（福州）公共资源交易平台",
    },
    {
      value: "3",
      label: "随行易交易（泉州）公共资源交易平台",
    },
    {
      value: "4",
      label: "随行易交易（宁德）公共资源交易平台",
    },
    {
      value: "5",
      label: "随行易交易（漳州）公共资源交易平台",
    },
    {
      value: "6",
      label: "随行易交易（龙岩）公共资源交易平台",
    },
    {
      value: "7",
      label: "随行易交易（莆田）公共资源交易平台",
    },
  ],
  FJGGZY_FILE_LIST: [
    // 福建省公共资源附件
    {
      name: "立项批复文件（项目审批核准文件）", // 附件名称
      key: "SGG_LXPFWJ", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标文件附件",
      key: "SGG_ZBWJFJ",
      val: [],
      isUpload: true,
      limit: "",
    },
    {
      name: "招标公告PDF文件（招标人或其代理机构盖章并由项目负责人签名或者电子签名）",
      key: "SGG_ZBGGPDFWJ",
      val: [],
      isUpload: true,
      limit: "",
    },
    {
      name: "招标公告电子签章文件（招标人或其代理机构盖章并由项目负责人签名或者电子签名）",
      key: "SGG_ZBGGDZQZWJ",
      val: [],
      isUpload: true,
      limit: "",
    },
    {
      name: "主要负责人的授权书",
      key: "SGG_ZYFZRDSQS",
      val: [],
      isUpload: true,
      limit: "",
    },
    {
      name: "资金来源落实证明文件",
      key: "SGG_ZJLYLSZMWJ",
      val: [],
      isUpload: true,
      limit: "",
    },
    {
      name: "招标代理合同",
      key: "SGG_ZBDLHT",
      val: [],
      isUpload: false,
      limit: "",
    },
    {
      name: "公共资源交易入场登记表",
      key: "SGG_GGZYJYRCDJB",
      val: [],
      isUpload: false,
      limit: "",
    },
    {
      name: "招标代理机构承诺书",
      key: "SGG_ZBDLJGCNS",
      val: [],
      isUpload: false,
      limit: "",
    },
    {
      name: "其他招标代理机构认为需要上传的文件资料",
      key: "SGG_QTZBDLJGRWXYSCDWJZL",
      val: [],
      isUpload: false,
      limit: "",
    },
    {
      name: "入场登记表中由行政主管部门明确入场意见",
      key: "SGG_RCDJBZYXZZGBMMQRCYJ",
      val: [],
      isUpload: false,
      limit: "",
    },
    {
      name: "加盖电子印章的澄清、答疑及补充PDF电子文件",
      key: "SGG_JGDZYZDCQDYJBCPDFDZWJ",
      val: [],
      isUpload: false,
      limit: "",
    },
    {
      name: "投标邀请书",
      key: "SGG_TBYQS",
      val: [],
      isUpload: false,
      limit: "",
    },
  ],
  XM_FILE_LIST: [
    // 厦门附件

    /*海迈附件*/
    {
      name: "投资概算批复（资金来源构成为财政投融资）", // 附件名称
      key: "XM_INVESTMENT_ESTIMATE_APPROVAL", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "代建合同", // 附件名称
      key: "XM_AGENT_CONTRACT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "立项或投资计划批文或其他文件--其他按文件", // 附件名称
      key: "XM_PROJECT_OTHER_FILES", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "投标邀请书PDF电子文件", // 附件名称
      key: "XM_INVITE_DOC", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: ".pdf", // 要求格式
    },
    {
      name: "项目审批或核准或备案文件", // 附件名称
      key: "XM_TENDER_PROJECT_APPROVAL_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "资金来源落实证明文件", // 附件名称
      key: "XM_FUND_SOURCE_CERTIFY_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "主要负责人的授权书", // 附件名称
      key: "XM_CORPORATION_AUTHORITY_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "入场登记表中由行政主管部门明确入场意见", // 附件名称
      key: "XM_PROJECT_REG_APPROVE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "其他招标代理机构认为需要上传的文件资料", // 附件名称
      key: "XM_OTHER_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标代理机构承诺书", // 附件名称
      key: "XM_AGENT_COMMIT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "公共资源交易入场登记表", // 附件名称
      key: "XM_PROJECT_REG", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标代理合同", // 附件名称
      key: "XM_TENDER_AGENT_CONTRACT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标公告电子签章文件（招标人或其代理机构盖章并由项目负责人签名或者电子签名）", // 附件名称
      key: "XM_TENDER_NOTICES_SIGN", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标公告PDF文件（招标人或其代理机构盖章并由项目负责人签名或者电子签名）", // 附件名称
      key: "XM_TENDER_NOTICE", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: ".pdf", // 要求格式
    },
    {
      name: "招标文件附件", // 附件名称
      key: "XM_TENDER_FILE_ATTACHS", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标文件", // 附件名称
      key: "XM_TENDER_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "立项批复文件（项目审批核准文件）", // 附件名称
      key: "XM_PROJECT_APPROVAL_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
    },

    {
      name: "工程造价文件", // 附件名称
      key: "XM_PROJECT_COST_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "工程控制价书（XML文件）", // 附件名称
      key: "XM_CONTROL_PRICE_BOOK", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: ".xml", // 要求格式
    },
    {
      name: "工程建设项目招标控制价告知单（招标人或其代理机构盖章并由项目负责人签名或者电子签名）", // 附件名称
      key: "XM_CONTROL_PRICE_NOTICE_SIGN", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "工程建设项目招标控制价告知单", // 附件名称
      key: "XM_CONTROL_PRICE_NOTICE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "控制价其他附件", // 附件名称
      key: "XM_CONTROL_OTHER_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "工程成本预警价书或控制价书（BA文件）", // 附件名称
      key: "XM_CONTROL_WARNING_BOOKBA", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "工程成本预警价书或控制价书（文件）", // 附件名称
      key: "XM_CONTROL_WARNING_BOOK", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "造价站备案证明", // 附件名称
      key: "XM_CONSTRUCTION_REGISTER_CERT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "财政投融资建设工程控制价审核结论书", // 附件名称
      key: "XM_FINANCE_EXAMINE_NOTICE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "公告其他资料", // 附件名称
      key: "XM_TENDER_OTHER_FILE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "施工现场项目管理人员配备分项评审标准（招标人或其代理机构盖章并由项目负责人签名或者电子签名）", // 附件名称
      key: "XM_CONSTRUCTION_MANGER_ITEM_SIGN", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "满足招标需要的设计图纸及技术资料（招标人或其代理机构盖章并由项目负责人签名或者电子签名）", // 附件名称
      key: "XM_DESIGN_DRAWINGS_SIGN", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },

    {
      name: "项目选址意见书", // 附件名称
      key: "XM_PROJECT_PREMISSION_NOTES", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "建设工程项目报建表", // 附件名称
      key: "XM_PROJECT_APPLICATION_FORM", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "土地出让合同（含规划指标的地块宗地界地址图）", // 附件名称
      key: "XM_LAND_TRANSFER_CONTRACT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "建设工程规划许可证", // 附件名称
      key: "XM_PROJECT_PLAN_PERMIT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标人依法成立的文件或者法人资格证明材料", // 附件名称
      key: "XM_TENDEREE_CERTIFICATE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标人设立的招标组织机构基本情况有关资料", // 附件名称
      key: "XM_TENDEREE_BASEINFO", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "拟从事招标工作的工程技术、造价及管理人员名单、职称证书或者执业资格证书和工作经历的证明材料", // 附件名称
      key: "XM_TENDERING_WORK", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标人或专业人员以往招标业绩的证明材料", // 附件名称
      key: "XM_TENDER_PERFORMANCE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标代理协议书", // 附件名称
      key: "XM_TENDER_AGENT_AGREEMENT", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标代理机构营业执照", // 附件名称
      key: "XM_TENDER_AGENT_LICENSE", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "招标代理机构资格证书", // 附件名称
      key: "XM_TENDER_AGENT_QUALIFICATION", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "满足招标需要的设计图纸及技术资料", // 附件名称
      key: "XM_DESIGN_DRAWINGS", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "施工现场项目管理人员配备分项评审标准", // 附件名称
      key: "XM_CONSTRUCTION_MANGER_ITEM", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "关于招标信息发布有关事项的声明", // 附件名称
      key: "XM_BID_INFORMATION", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "承诺函", // 附件名称
      key: "XM_COMMIT_LETTER", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
    {
      name: "设计概算书（资金来源构成为非财政投融资）", // 附件名称
      key: "XM_INVESTMENT_APPROVAL", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      limit: "", // 要求格式
    },
  ],
  QZ_FILE_LIST: [
    // 泉州市公共资源附件列表
    {
      name: "立项批复文件（项目审批核准文件）", // 附件名称
      key: "SGG_LXPFWJ", // 引文名称
      val: [], // 上传附件列表
      isUpload: true, // 是否必传
      limit: "", // 要求格式
      nameRequire: ["立项批复文件.pdf"],
    },
    {
      name: "招标文件附件",
      key: "SGG_ZBWJFJ",
      val: [],
      isUpload: true,
      limit: "",
      nameRequire: ["预算（项目名称）.rar", "图纸（项目名称）.rar", "......"],
    },
    {
      name: "招标公告PDF文件（招标人或其代理机构盖章并由项目负责人签名或者电子签名）",
      key: "SGG_ZBGGPDFWJ",
      val: [],
      isUpload: true,
      limit: "",
      nameRequire: ["招标公告PDF文件.pdf"],
    },
    {
      name: "招标公告电子签章文件（招标人或其代理机构盖章并由项目负责人签名或者电子签名）",
      key: "SGG_ZBGGDZQZWJ",
      val: [],
      isUpload: true,
      limit: "",
      nameRequire: ["招标公告电子签章文件.pdf"],
    },
    {
      name: "主要负责人的授权书",
      key: "SGG_ZYFZRDSQS",
      val: [],
      isUpload: true,
      limit: "",
      nameRequire: ["主要负责人的授权书.pdf"],
    },
    {
      name: "资金来源落实证明文件",
      key: "SGG_ZJLYLSZMWJ",
      val: [],
      isUpload: true,
      limit: "",
      nameRequire: ["资金来源落实证明文件.pdf"],
    },
    {
      name: "工程预算书", // 附件名称
      key: "HM_PROJECT_BUDGET", // 引文名称
      val: [], // 上传附件列表
      isUpload: false, // 是否必传
      multiple: false, // 是否可传多个文件，默认可以
      limit: ".zip,.rar", // 要求格式
      nameRequire: ["工程预算书.rar"],
    },
    {
      name: "招标代理合同",
      key: "SGG_ZBDLHT",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["招标代理合同.pdf"],
    },
    {
      name: "公共资源交易入场登记表",
      key: "SGG_GGZYJYRCDJB",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["公共资源交易入场登记表.pdf"],
    },
    {
      name: "招标代理机构承诺书",
      key: "SGG_ZBDLJGCNS",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["招标代理机构承诺书.pdf"],
    },
    {
      name: "其他招标代理机构认为需要上传的文件资料",
      key: "SGG_QTZBDLJGRWXYSCDWJZL",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["其他招标代理机构认为需要上传的文件资料.pdf"],
    },
    {
      name: "入场登记表中由行政主管部门明确入场意见",
      key: "SGG_RCDJBZYXZZGBMMQRCYJ",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["入场登记表中由行政主管部门明确入场意见.pdf"],
    },
    {
      name: "加盖电子印章的澄清、答疑及补充PDF电子文件",
      key: "SGG_JGDZYZDCQDYJBCPDFDZWJ",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["加盖电子印章的澄清、答疑及补充PDF电子文件.pdf"],
    },
    {
      name: "投标邀请书",
      key: "SGG_TBYQS",
      val: [],
      isUpload: false,
      limit: "",
      nameRequire: ["投标邀请书.pdf"],
    },
  ],
  NEW_MARGIN_PAY_TYPE: [
    {
      value: "现金",
      label: "现金",
    },
    {
      value: "支票",
      label: "支票",
    },
    {
      value: "银行保函",
      label: "银行保函",
    },
    {
      value: "电子保函",
      label: "电子保函",
    },
    {
      value: "年度保证金",
      label: "年度保证金",
    },
  ],
  XM_MARGIN_PAY_TYPE: [
    {
      value: "现金",
      label: "现金",
    },
    {
      value: "支票",
      label: "支票",
    },
    {
      value: "银行保函",
      label: "银行保函",
    },
    {
      value: "电子保函",
      label: "电子保函",
    },
  ],
  MARGIN_PAY_TYPE_2022: [
    // {
    //   Value: "无要求",
    //   Name: "无要求",
    // },
    {
      Value: "现金",
      Name: "现金",
    },
    {
      Value: "电子保函",
      Name: "电子保函",
    },
    {
      Value: "其他",
      Name: "其他",
    },
  ],
  XM_NOTICE_OPTIONS: [
    // 厦门发布公告媒介下拉框选项
    {
      Value: "中国采购与招标网（网址：www.chinabidding.com.cn）",
      Name: "中国采购与招标网（网址：www.chinabidding.com.cn）",
    },
    {
      Value: "厦门市公共资源交易网（网址：http://zyjy.as.xm.gov.cn/）",
      Name: "厦门市公共资源交易网（网址：http://zyjy.as.xm.gov.cn/）",
    },
    {
      Value: "福建招标与采购网（网址：www.fjbid.gov.cn）",
      Name: "福建招标与采购网（网址：www.fjbid.gov.cn）",
    },
  ],

  simpleTyScoreSummary: ["所有专家评分求平均", "所有专家评分求和"],

  TENDERER_NAME_AREA: ["3502"] /*绑定招标人账号的地区：厦门*/,
};
export const prefaceData = {
  IS_REPORT: {
    Key: "IS_REPORT",
    Name: "是否在省监督平台报建及备案",
    Type: "componentId=select&trueValue=是",
    Value: "是",
    Refs: [
      hooks.setFormItemRequired(0, 3, ["REPORT_NUMBER", "RECORD_NUMBER"], true),
      hooks.setFormItemDisabled(0, 3, ["REPORT_NUMBER", "RECORD_NUMBER"], false),

      // hooks.setFormItemValue(["REPORT_NUMBER", "RECORD_NUMBER"], "", false),

      // hooks.setFormItemValue(["select_IS_REPORT_PROVINCE"], "是", true),
      // hooks.setFormItemValue(["IS_REPORT_PROVINCE"], true, true),
      hooks.setFormItemWithCustom("IS_REPORT"),
    ],
    Options: [
      {
        Name: "是",
        Value: "是",
      },
      {
        Name: "否",
        Value: "否",
      },
    ],
  },
  REPORT_NUMBER: {
    Key: "REPORT_NUMBER",
    Name: "报建编号",
    Type: "componentId=code&type=GetBaoJianInfo&url=/SL_Api/GetBaoJianInfo",
  },
  IS_REPORT_PROVINCE: {
    Key: "IS_REPORT_PROVINCE",
    Name: "是否报送省公共服务平台",
    Type: "componentId=select&trueValue=是",
    Value: "是",
    Disabled: true,
    Options: [
      {
        Name: "是",
        Value: "是",
      },
      {
        Name: "否",
        Value: "否",
      },
    ],
  },
  RECORD_NUMBER: {
    Key: "RECORD_NUMBER",
    Name: "备案编号",
    Type: "componentId=code&type=GetBeiAnInfo&url=/SL_Api/GetBeiAnInfo",
  },
  PROJECT_CODE: {
    Key: "PROJECT_CODE",
    Name: "项目编号",
    Type: "componentId=input",
    Disabled: true,
    DisabledMsg: "自动生成",
  },
  PROJECT_CODE: {
    Key: "PROJECT_CODE",
    Name: "项目编号",
    Type: "componentId=input",
    Disabled: true,
    Required: false,
  },
  PROJECT_NAME: {
    Key: "PROJECT_NAME",
    Name: "项目名称",
    Type: "componentId=input",
  },
  REGION_CODE: {
    Key: "REGION_CODE",
    Name: "项目所在行政区域代码",
    Type: "componentId=areacode&disabledRoot=true",
  },
  RELATE_CODE: {
    Key: "select_RELATE_CODE",
    Name: "项目类别关联代码",
    Type: "componentId=select&EnumKey=RELATE_CODE",
    Refs: [hooks.setFormItemWithCustom("RELATE_CODE")],
    Options: [
      {
        Value: "固定资产类项目",
        Name: "固定资产类项目",
        EnumValue: "1",
      },
      {
        Value: "其他",
        Name: "其他",
        EnumValue: "0",
      },
    ],
  },
  INVEST_PROJECT_CODE: {
    Key: "INVEST_PROJECT_CODE",
    Name: "投资项目统一代码",
    Type: "componentId=input",
    Rules: [rules.customValidator("INVEST_PROJECT_CODE")],
  },
  ADDRESS: {
    Key: "ADDRESS",
    Name: "项目地址",
    Type: "componentId=input",
  },
  LEGAL_PERSON: {
    Key: "LEGAL_PERSON",
    Name: "项目法人",
    Type: "componentId=input",
  },
  LEGAL_PERSON_CODE: {
    Key: "LEGAL_PERSON_CODE",
    Name: "项目法人代码",
    Type: "componentId=input",
    Rules: [
      rules.customValidator("LEGAL_PERSON_CODE"),
      // rules.societyCode(),
      // rules.orgCode(),
    ],
  },
  IS_OPEN_INVITATION: {
    Key: "IS_OPEN_INVITATION",
    Name: "是否公开邀请",
    Type: "componentId=select&trueValue=公开",
    Refs: [hooks.setFormItemValue(["IS_OPEN"], "公开", true)],
    Options: [
      {
        Value: "公开",
        Name: "公开",
      },
      {
        Value: "不公开",
        Name: "不公开",
      },
    ],
  },
  /* 福安只能公开邀请 */
  FA_IS_OPEN_INVITATION: {
    Key: "IS_OPEN_INVITATION",
    Name: "是否公开邀请",
    Type: "componentId=select&trueValue=公开",
    Refs: [hooks.setFormItemValue(["IS_OPEN"], "公开", true)],
    Options: [
      {
        Value: "公开",
        Name: "公开",
      },
    ],
  },
  IS_OPEN_INVITATION_COMPANY: {
    Key: "IS_OPEN_INVITATION_COMPANY",
    Name: "是否公开邀请单位信息",
    Type: "componentId=select&trueValue=公开",
    Options: [
      {
        Value: "公开",
        Name: "公开",
      },
      {
        Value: "不公开",
        Name: "不公开",
      },
    ],
  },
  INDUSTRIES_TYPE: {
    Key: "INDUSTRIES_TYPE",
    Name: "项目行业分类",
    Type: "componentId=input",
    Disabled: true,
  },
  FUND_SOURCE: {
    Key: "FUND_SOURCE",
    Name: "资金来源",
    Type: "componentId=input",
  },
  XM_FUND_SOURCE: {
    Key: "FUND_SOURCE",
    Name: "厦门资金来源",
    Type: "componentId=select",
    Value: "国有",
    Options: [
      {
        Value: "财政投融资项目",
        Name: "财政投融资项目",
      },
      {
        Value: "国有",
        Name: "国有",
      },
      {
        Value: "集体",
        Name: "集体",
      },
      {
        Value: "外资",
        Name: "外资",
      },
      {
        Value: "私人",
        Name: "私人",
      },
      {
        Value: "其他项目",
        Name: "其他项目",
      },
    ],
  },
  CONTRIBUTION_SCALE: {
    Key: "CONTRIBUTION_SCALE",
    Name: "出资比例",
    Type: "componentId=input",
  },
  PROJECT_SCALE: {
    Key: "PROJECT_SCALE",
    Name: "项目规模",
    Type: "componentId=input",
    Rules: [rules.limitTextLength([0, 2000])],
  },
  CONTACTOR: {
    Key: "CONTACTOR",
    Name: "建设单位联系人",
    Type: "componentId=input",
  },
  CONTACT_INFORMATION: {
    Key: "CONTACT_INFORMATION",
    Name: "建设单位联系方式",
    Type: "componentId=input",
  },
  APPROVAL_NAME: {
    Key: "APPROVAL_NAME",
    Name: "项目审批文件名称",
    Type: "componentId=input",
    Rules: [rules.limitTextLength([0, 200])],
  },
  APPROVAL_NUMBER: {
    Key: "APPROVAL_NUMBER",
    Name: "项目审批文号",
    Type: "componentId=input",
  },
  APPROVAL_AUTHORITY: {
    Key: "APPROVAL_AUTHORITY",
    Name: "项目审批单位",
    Type: "componentId=input",
  },
  CREATE_TIME: {
    Key: "CREATE_TIME",
    Name: "项目建立时间",
    Type: "componentId=date&format=yyyy-MM-dd",
  },
  IsMultiSegment: {
    Key: "IsMultiSegment",
    Name: "是否为多标段",
    Type: "componentId=select&trueValue=是",
    Refs: [hooks.setFormItemValue(["Is_MultiSegment"], "是", true)],
    Options: [
      {
        Value: "是",
        Name: "是",
      },
      {
        Value: "否",
        Name: "否",
      },
    ],
  },
  CONTRACT_RECKON_PRICE: {
    Key: "CONTRACT_RECKON_PRICE",
    Name: "标段合同估算价(元)",
    Type: "componentId=input",
    Rules: [rules.numberValidWithMaxDecimal(2)],
  },
  IS_MUST_BIDDING_BY_LAW: {
    Key: "IS_MUST_BIDDING_BY_LAW",
    Name: "是否依法必须招标",
    Type: "componentId=select&trueValue=是",
    Options: [
      {
        Value: "是",
        Name: "是",
      },
      {
        Value: "否",
        Name: "否",
      },
    ],
  },
  TENDER_PROJECT_CODE: {
    Key: "TENDER_PROJECT_CODE",
    Name: "招标项目编号",
    Type: "componentId=input",
    Disabled: true,
    Required: false,
  },
  UNIFIED_DEAL_CODE: {
    Key: "UNIFIED_DEAL_CODE",
    Name: "统一交易标识码",
    Type: "componentId=input",
    Disabled: true,
    Required: false,
  },
  TENDER_PROJECT_NAME: {
    Key: "TENDER_PROJECT_NAME",
    Name: "招标项目名称",
    Type: "componentId=input",
  },
  TENDER_PROJECT_TYPE: {
    Key: "TENDER_PROJECT_TYPE",
    Name: "招标项目类型",
    Type: "componentId=input",
    Disabled: true,
  },
  TENDER_CONTENT: {
    Key: "TENDER_CONTENT",
    Name: "招标内容与范围及招标方案说明",
    Type: "componentId=input",
  },
  OWNER_NAME: {
    Key: "OWNER_NAME",
    Name: "项目业主名称",
    Type: "componentId=input",
    Rules: [rules.limitTextLength([0, 200])],
  },
  TENDERER_NAME: {
    Key: "TENDERER_NAME",
    Name: "招标人名称",
    Type: "componentId=autocomplete",
    OptionsUrl: "/TenderProject/TenderFilledRecords?key=TENDERER_NAME&limit=20",
    Refs: [hooks.setFormItemWithCustom("TENDERER_NAME")],
  },
  TENDERER_REGION_CODE: {
    Key: "TENDERER_REGION_CODE",
    Name: "招标人企业注册所在地",
    Type: "componentId=areacode",
  },
  TENDERER_PROPERTY: {
    Key: "select_TENDERER_PROPERTY",
    Name: "招标人企业性质",
    Type: "componentId=select&EnumKey=TENDERER_PROPERTY",
    Options: [
      {
        Value: "国有企业",
        Name: "国有企业",
        EnumValue: "1",
      },
      {
        Value: "集体所有制企业",
        Name: "集体所有制企业",
        EnumValue: "2",
      },
      {
        Value: "联营企业",
        Name: "联营企业",
        EnumValue: "3",
      },
      {
        Value: "三资企业",
        Name: "三资企业",
        EnumValue: "4",
      },
      {
        Value: "私营企业",
        Name: "私营企业",
        EnumValue: "5",
      },
      {
        Value: "事业单位",
        Name: "事业单位",
        EnumValue: "6",
      },
      {
        Value: "其他",
        Name: "其他",
        EnumValue: "9",
      },
    ],
  },
  IS_REBID: {
    Key: "select_IS_REBID",
    Name: "是否重新招标",
    Type: "componentId=select&EnumKey=IS_REBID&EnumValue=0",
    Refs: [hooks.setFormItemWithCustom("IS_REBID")],
    Options: [
      {
        Value: "是",
        Name: "是",
        EnumValue: "1",
      },
      {
        Value: "否",
        Name: "否",
        EnumValue: "0",
      },
    ],
  },
  REBID_TENDER_PROJECT_CODE: {
    Key: "REBID_TENDER_PROJECT_CODE",
    Name: "重新招标原招标项目编号",
    Type: "componentId=input",
    Rules: [rules.customValidator("REBID_TENDER_PROJECT_CODE")],
  },
  TENDERER_CODE_TYPE: {
    Key: "TENDERER_CODE_TYPE",
    Name: "招标人类别",
    Type: "componentId=select",
    Value: "法人",
    Options: [
      {
        Value: "自然人",
        Name: "自然人",
      },
      {
        Value: "法人",
        Name: "法人",
      },
      {
        Value: "其他",
        Name: "其他",
      },
    ],
  },
  TENDERER_CODE: {
    Key: "TENDERER_CODE",
    Name: "招标人代码",
    Type: "componentId=input",
    Rules: [rules.customValidator("TENDERER_CODE")],
  },
  TENDERER_CORPORATE_IDENTITY: {
    Key: "TENDERER_CORPORATE_IDENTITY",
    Name: "招标人企业标识",
    Type: "componentId=input",
  },
  TENDERER_ROLE: {
    Key: "TENDERER_ROLE",
    Name: "招标人角色",
    Type: "componentId=select",
    Value: "招标人",
    Options: [
      {
        Value: "招标人",
        Name: "招标人",
      },
      {
        Value: "招标代理机构",
        Name: "招标代理机构",
      },
      {
        Value: "投标人",
        Name: "投标人",
      },
      {
        Value: "其他",
        Name: "其他",
      },
    ],
  },
  TENDER_AGENCY_NAME: {
    Key: "TENDER_AGENCY_NAME",
    Name: "招标代理机构名称",
    Type: "componentId=autocomplete",
    OptionsUrl: "/TenderProject/TenderFilledRecords?key=TENDER_AGENCY_NAME&limit=20",
    Refs: [hooks.setFormItemWithCustom("TENDER_AGENCY_NAME")],
  },
  TENDER_AGENCY_CODE_TYPE: {
    Key: "TENDER_AGENCY_CODE_TYPE",
    Name: "招标代理机构类别",
    Type: "componentId=select",
    Value: "法人",
    Options: [
      {
        Value: "自然人",
        Name: "自然人",
      },
      {
        Value: "法人",
        Name: "法人",
      },
      {
        Value: "其他",
        Name: "其他",
      },
    ],
  },
  TENDER_AGENCY_CODE: {
    Key: "TENDER_AGENCY_CODE",
    Name: "招标代理机构代码",
    Type: "componentId=input",
    Rules: [rules.patternCustom(/^[a-zA-Z0-9]{18}$/, "请输入18位")],
  },
  TENDER_AGENCY_ROLE: {
    Key: "TENDER_AGENCY_ROLE",
    Name: "招标代理机构角色",
    Type: "componentId=select",
    Value: "招标代理机构",
    Options: [
      {
        Value: "招标人",
        Name: "招标人",
      },
      {
        Value: "招标代理机构",
        Name: "招标代理机构",
      },
      {
        Value: "投标人",
        Name: "投标人",
      },
      {
        Value: "其他",
        Name: "其他",
      },
    ],
  },
  TENDER_MODE: {
    Key: "TENDER_MODE",
    Name: "招标方式",
    Type: "componentId=input",
    Disabled: true,
  },
  TENDER_ORGANIZE_FORM: {
    Key: "TENDER_ORGANIZE_FORM",
    Name: "招标组织形式",
    Type: "componentId=select",
    Value: "委托招标",
    Options: [
      {
        Value: "自行招标",
        Name: "自行招标",
      },
      {
        Value: "委托招标",
        Name: "委托招标",
      },
      {
        Value: "其他",
        Name: "其他",
      },
    ],
  },
  SUPERVISE_DEPT_NAME: {
    Key: "SUPERVISE_DEPT_NAME",
    Name: "监督部门名称",
    Type: "componentId=input",
    Rules: [rules.customValidator("SUPERVISE_DEPT_NAME")],
  },
  SUPERVISE_DEPT_CODE: {
    Key: "SUPERVISE_DEPT_CODE",
    Name: "监督部门代码",
    Type: "componentId=input",
    Rules: [rules.patternCustom(/^.{18}$/, "请输入18位")],
    Required: false,
  },
  APPROVE_DEPT_NAME: {
    Key: "APPROVE_DEPT_NAME",
    Name: "审核部门名称",
    Type: "componentId=input",
    /* 和监督部门名称一样的验证规则 */
    Rules: [rules.customValidator("SUPERVISE_DEPT_NAME")],
  },
  APPROVE_DEPT_CODE: {
    Key: "APPROVE_DEPT_CODE",
    Name: "审核部门代码",
    Type: "componentId=input",
    Required: false,
  },
  END_ALL_DATE: {
    Key: "END_ALL_DATE",
    Name: "预计完工日期",
    Type: "componentId=datetime&format=yyyy-MM-dd",
  },
  DOC_PRICE: {
    Key: "DOC_PRICE",
    Name: "招标文件费用（元）",
    Type: "componentId=input&firstChange=true",
    Rules: [rules.numberValidWithDecimal(2)],
    Refs: [hooks.setFormItemWithCustom("DOC_PRICE")],
  },
  royalty_parameters: {
    Key: "royalty_parameters",
    Name: "支付宝收款账号",
    Type: "componentId=select",
    OptionsFromStore: "AlipayAccounts",
    Refs: [hooks.setFormItemWithCustom("royalty_parameters")],
  },
  ROYALTY_REAL_NAME: {
    Key: "ROYALTY_REAL_NAME",
    Name: "支付宝收款账号真实姓名",
    Type: "componentId=input",
    Disabled: true,
  },
  TECHNICA_DATA_DEPOSIT: {
    Key: "TECHNICA_DATA_DEPOSIT",
    Name: "技术资料押金（元）",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(2)],
  },
  TRADE_CENTER_SELECT: {
    Key: "TRADE_CENTER_SELECT",
    Name: "交易中心",
    Type: "componentId=tradingCenter",
  },
  /* 场外交易中心不能修改 */
  OUT_TRADE_CENTER_SELECT: {
    Key: "TRADE_CENTER_SELECT",
    Name: "交易中心",
    Type: "componentId=tradingCenter",
    Disabled: true,
  },
  OPEN_BID_SITE: {
    Key: "select_OPEN_BID_SITE",
    Name: "开标场地",
    Type: "componentId=select&EnumKey=OPEN_BID_SITE&noFirstChange=true",
    OptionsFromStore: "bookingOptions",
    Refs: [hooks.setFormItemWithCustom("OPEN_BID_SITE")],
  },
  SITE_BOOKING_NUM: {
    Key: "SITE_BOOKING_NUM",
    Name: "场地预约编号",
    Type: "componentId=input",
    Rules: [rules.customValidator("SITE_BOOKING_NUM")],
  },
  BID_OPEN_PLACE: {
    Key: "BID_OPEN_PLACE",
    Name: "开标地点",
    Type: "componentId=input",
    Rules: [rules.limitTextLength([0, 200])],
  },
  ___RomoteEval___: {
    Key: "___RomoteEval___",
    Name: "远程异地评标",
    Type: "componentId=select&trueValue=启动&noFirstChange=true",
    Refs: [hooks.setFormItemWithCustom("___RomoteEval___")],
    Options: [
      {
        Value: "启动",
        Name: "启动",
      },
      {
        Value: "不启动",
        Name: "不启动",
      },
    ],
  },
};
export const dockData = {
  /* 福建省 */
  ISUNION: {
    Key: "ISUNION",
    Name: "是否联合招标",
    Type: "componentId=select&firstChange=true",
    Refs: [hooks.setFormItemWithCustom("ISUNION")],
    Options: [
      {
        Value: "是",
        Name: "是",
      },
      {
        Value: "否",
        Name: "否",
      },
    ],
  },
  UNIONTENDER: {
    Key: "UNIONTENDER",
    Name: "联合招标人",
    Type: "componentId=input",
  },
  UNIONCODE: {
    Key: "UNIONCODE",
    Name: "联合招标人组织机构代码",
    Type: "componentId=input",
  },
  UNIONCODETYPE: {
    Key: "UNIONCODETYPE",
    Name: "联合招标人类别",
    Type: "componentId=input",
  },
  XM_BID_SECTION_NUM: {
    Key: "XM_BID_SECTION_NUM",
    Name: "标段（包）招标次数",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
  },
  PRICE_FORM_CODE: {
    Key: "select_PRICE_FORM_CODE",
    Name: "价款形式代码",
    Type: "componentId=select&EnumKey=PRICE_FORM_CODE",
    Refs: [hooks.setFormItemWithCustom("PRICE_FORM_CODE")],
    Options: [
      {
        Value: "金额",
        Name: "金额",
        EnumValue: "1",
      },
      {
        Value: "费率/比率/优惠率/合格率等",
        Name: "费率/比率/优惠率/合格率等",
        EnumValue: "2",
      },
      {
        Value: "单价",
        Name: "单价",
        EnumValue: "3",
      },
      {
        Value: "其他形式",
        Name: "其他形式",
        EnumValue: "9",
      },
    ],
  },
  MARGIN_PERCENT: {
    Key: "MARGIN_PERCENT",
    Name: "投标保证金比率或其他",
    Type: "componentId=input",
  },
  QUALIFICATION_LEVEL: {
    Key: "select_QUALIFICATION_LEVEL",
    Name: "投标资格要求等级",
    Type: "componentId=select&EnumKey=QUALIFICATION_LEVEL",
    Options: [
      {
        Value: "特级",
        Name: "特级",
        EnumValue: "01",
      },
      {
        Value: "一级",
        Name: "一级",
        EnumValue: "02",
      },
      {
        Value: "二级",
        Name: "二级",
        EnumValue: "03",
      },
      {
        Value: "三级",
        Name: "三级",
        EnumValue: "04",
      },
      {
        EnumValue: "05",
        Value: "四级",
        Name: "四级",
      },
      {
        EnumValue: "06",
        Value: "甲级",
        Name: "甲级",
      },
      {
        EnumValue: "07",
        Value: "乙级",
        Name: "乙级",
      },
      {
        EnumValue: "08",
        Value: "丙级",
        Name: "丙级",
      },
      {
        EnumValue: "09",
        Value: "丁级",
        Name: "丁级",
      },
      {
        EnumValue: "10",
        Value: "暂定级（预乙级）",
        Name: "暂定级（预乙级）",
      },
      {
        EnumValue: "11",
        Value: "初级",
        Name: "初级",
      },
      {
        EnumValue: "12",
        Value: "中级",
        Name: "中级",
      },
      {
        EnumValue: "13",
        Value: "高级",
        Name: "高级",
      },
    ],
  },
  FJGGZY_FILE_LIST: {
    Key: "FJGGZY_FILE_LIST",
    Name: "福建省公共资源附件列表",
    Type: "componentId=fileTable",
  },
  /* 厦门 */
  COMPILING_BUDGET_PRICE: {
    Key: "COMPILING_BUDGET_PRICE",
    Name: "编制预算价（元）",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
    Required: false,
  },
  COST_EARLY_WARNING_PRICE: {
    Key: "COST_EARLY_WARNING_PRICE",
    Name: "成本预警价（元）",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
    Required: false,
  },
  PROJECT_BUDGET_PRICE: {
    Key: "PROJECT_BUDGET_PRICE",
    Name: "工程预算价（元）",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
    Required: false,
  },
  TenderAgencyFeeChargeStandard: {
    Key: "TenderAgencyFeeChargeStandard",
    Name: "招标代理费收费标准",
    Type: "componentId=input",
  },
  TenderAgencyFeePayer: {
    Key: "TenderAgencyFeePayer",
    Name: "招标代理费支付方",
    Type: "componentId=input",
  },
  JIANSHEZJZMZJ: {
    Key: "JIANSHEZJZMZJ",
    Name: "建设资金到位证明及金额",
    Type: "componentId=input",
  },
  SHUI: {
    Key: "SHUI",
    Name: "三通一平-水",
    Type: "componentId=input",
  },
  DIAN: {
    Key: "DIAN",
    Name: "三通一平-电",
    Type: "componentId=input",
  },
  LU: {
    Key: "LU",
    Name: "三通一平-路",
    Type: "componentId=input",
  },
  CDPZ: {
    Key: "CDPZ",
    Name: "三通一平-场地平整",
    Type: "componentId=input",
  },
  CDKC: {
    Key: "CDKC",
    Name: "场地勘察",
    Type: "componentId=input",
  },
  SGTZ: {
    Key: "SGTZ",
    Name: "施工图纸",
    Type: "componentId=input",
  },
  ISIMPORTANTPRO: {
    Key: "ISIMPORTANTPRO",
    Name: "重点工程类型",
    Type: "componentId=select",
    Value: "市",
    Options: [
      {
        Value: "国家",
        Name: "国家",
      },
      {
        Value: "省",
        Name: "省",
      },
      {
        Value: "市",
        Name: "市",
      },
      {
        Value: "否",
        Name: "否",
      },
    ],
  },
  SOURCEGOV: {
    Key: "SOURCEGOV",
    Name: "资金来源构成政府投融资",
    Type: "componentId=input",
    Rules: [rules.customValidator("SOURCEGOV")],
  },
  SOURCESTATE: {
    Key: "SOURCESTATE",
    Name: "资金来源构成国有",
    Type: "componentId=input",
    Rules: [rules.customValidator("SOURCEGOV")],
  },
  SOURCECOLLECTIVE: {
    Key: "SOURCECOLLECTIVE",
    Name: "资金来源构成集体",
    Type: "componentId=input",
    Rules: [rules.customValidator("SOURCEGOV")],
  },
  SOURCEOUT: {
    Key: "SOURCEOUT",
    Name: "资金来源构成外资",
    Type: "componentId=input",
    Rules: [rules.customValidator("SOURCEGOV")],
  },
  SOURCEPRIVATE: {
    Key: "SOURCEPRIVATE",
    Name: "资金来源构成私人",
    Type: "componentId=input",
    Rules: [rules.customValidator("SOURCEGOV")],
  },
  SOURCEOTHER: {
    Key: "SOURCEOTHER",
    Name: "资金来源构成其他",
    Type: "componentId=input",
    Rules: [rules.customValidator("SOURCEGOV")],
  },
  BUILDINGAREA: {
    Key: "BUILDINGAREA",
    Name: "建筑面积",
    Type: "componentId=input",
    Rules: [rules.limitTextLength([0, 25])],
  },
  INSTALLATIONCOST: {
    Key: "INSTALLATIONCOST",
    Name: "建安造价（万元）",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(4)],
  },
  IS_NOTARIZED: {
    Key: "select_IS_NOTARIZED",
    Name: "是否需要公证机构",
    Type: "componentId=select&EnumKey=IS_NOTARIZED",
    Options: [
      {
        EnumValue: "1",
        Value: "是",
        Name: "是",
      },
      {
        EnumValue: "0",
        Value: "否",
        Name: "否",
      },
    ],
    Required: false,
  },
  NOTARY_OFFICE: {
    Key: "select_NOTARY_OFFICE",
    Name: "公证机构",
    Type: "componentId=select&EnumKey=NOTARY_OFFICE",
    Options: [
      {
        EnumValue: "42660115-3",
        Value: "厦门市公证处",
        Name: "厦门市公证处",
      },
      {
        EnumValue: "42661913-4",
        Value: "厦门市同安区公证处",
        Name: "厦门市同安区公证处",
      },
      {
        EnumValue: "42661335-7",
        Value: "厦门市海沧区公证处",
        Name: "厦门市海沧区公证处",
      },
      {
        EnumValue: "42661438-4",
        Value: "厦门市集美区公证处",
        Name: "厦门市集美区公证处",
      },
      {
        EnumValue: "B3690074-8",
        Value: "厦门市鹭江公证处",
        Name: "厦门市鹭江公证处",
      },
    ],
  },
  XM_FILE_LIST: {
    Key: "XM_FILE_LIST",
    Name: "厦门附件列表",
    Type: "componentId=fileTable",
  },
  /* 泉州 */
  HM_TENDERER_NUM: {
    Key: "HM_TENDERER_NUM",
    Name: "招标人代表人数",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
  },
  HM_BUSINESS_EXPERT_NUM: {
    Key: "HM_BUSINESS_EXPERT_NUM",
    Name: "商务专家人数",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
  },
  HM_TECHNICIAN_EXPERT_NUM: {
    Key: "HM_TECHNICIAN_EXPERT_NUM",
    Name: "技术专家人数",
    Type: "componentId=input",
    Rules: [rules.numberValidWithDecimal(0)],
  },
  HM_REGION_NAME: {
    Key: "HM_REGION_NAME",
    Name: "对严重失信行为作出裁决或行政处罚的主管部门行政区域",
    Type: "componentId=regionQz",
  },
  HM_IMPORTANT_LIMITE_TIME: {
    Key: "HM_IMPORTANT_LIMITE_TIME",
    Name: "重要节点工期",
    Type: "componentId=input",
    Rules: [rules.patternCustom(/(^[1-9]\d*(\.\d+)?$)|(^0(\.\d+)?$)/, "请输入数字")],
  },
  HM_PERSON_XX: {
    Key: "HM_PERSON_XX",
    Name: "人员信息",
    Type: "componentId=addableTableQz",
    TableColumns: [
      {
        Key: "PERSON",
        Name: "岗位名称",
        Type: "input",
        Width: "300px",
      },
      {
        Key: "NAME",
        Name: "姓名",
        Type: "input",
        Width: "300px",
      },
      {
        Key: "IDNUMBER",
        Name: "身份证号码",
        Type: "input",
        Width: "150px",
        Rules: [rules.patternCustom(/^[a-zA-Z0-9]{18}$/, "请输入18位数身份证号码")],
      },
      {
        Key: "PHONE",
        Name: "联系电话",
        Type: "input",
        Width: "150px",
        Rules: [rules.patternCustom(/1\d{10}/, "必须为有效电话号码")],
      },
    ],
  },
};

export default {
  namespaced: true,
  state: () => ({
    tenderProjectConfig: tenderProjectConfig,
    /* 工程量清单的各个范本的配置 */
    fileConfig: {},
  }),
  mutations: {
    setFileConfig(state, config) {
      state.fileConfig = config;
    },
  },
  actions: {
    initForm({ state, rootState }, params) {
      let { form } = rootState;
      let { tenderProjectConfig } = state;
      let IS_REPORT = true,
        IS_REPORT_PROVINCE = true,
        TECHNICAL_DOCUMENT = "不要求";
      let PRE_PERFORM_PRICE_MONEY = "",
        PERFORM_PRICE_MONEY_UNIT = "";
      if (params.eval === "综合评估法") {
        TECHNICAL_DOCUMENT = "要求";
      }
      let REGION_CODE = "",
        isBondOnline = false,
        isHasBond = false;
      if (params.regionId.indexOf("x") !== 0) {
        // REGION_CODE = params.regionId
      } else {
        IS_REPORT = false;
        IS_REPORT_PROVINCE = false;
        /*国资默认推送省公共服务平台*/
        if (params.regionId == "x60004") {
          IS_REPORT = false;
          IS_REPORT_PROVINCE = true;
        }
      }
      if (!(tenderProjectConfig.BZJ_ADDRESS.indexOf(params.region) < 0)) {
        isBondOnline = true;
        isHasBond = true;
      }
      if (params.regionId.indexOf("3505") === 0) {
        PRE_PERFORM_PRICE_MONEY = "中标合同金额";
        PERFORM_PRICE_MONEY_UNIT = "%";
      } else if (params.regionId.indexOf("3502") === 0) {
        PERFORM_PRICE_MONEY_UNIT = "万元";
      }
      let defaultFrom = {
        region: params.region, // 备案地区
        site: params.site /*判断场内场外*/,
        regionId: params.regionId, // 备案地区id
        type: params.type, // 招标项目类型（施工/勘察设计/监理/其他/材料采购/设备采购）
        way: params.way, // 招标方式（公开/邀请）
        eval: params.eval, // 评标办法
        evalId: params.evalId, // 评标办法id
        REGION_CODE: REGION_CODE, // 项目所在行政区域代码
        ADJUDICATION_AREA: params.region,
        TRADE_CENTER_SELECT: params.region, // 交易中心
        PLATFORM_CODE: "", // 交易系统标识码
        PUB_SERVICE_PLAT_CODE: "", // 公共服务平台标识码
        TENDER_PROJECT_TYPE: params.type, // 招标项目类型
        INDUSTRIES_TYPE: "水利", // 项目行业分类
        TENDER_MODE: params.way, // 招标方式
        EVALUATING_METHOD: params.eval, // 评标办法
        IS_REPORT: IS_REPORT, // 是否在省监督平台报建及备案
        select_IS_REPORT: IS_REPORT ? "是" : "否", // 是否在省监督平台报建及备案
        IS_REPORT_PROVINCE: IS_REPORT_PROVINCE, // 是否报送省公共服务平台
        select_IS_REPORT_PROVINCE: IS_REPORT_PROVINCE ? "是" : "否", // 是否报送省公共服务平台
        TRADING_PLATFORM: tenderProjectConfig.TRADING_PLATFORM, // 交易平台名称
        TRADING_PLATFORM_ADDRESS: tenderProjectConfig.TRADING_PLATFORM_ADDRESS, // 交易平台网址
        CUSTOMER_SERVICE_PHONE: tenderProjectConfig.CUSTOMER_SERVICE_PHONE, // 交易平台联系方式
        isBondOnline: isBondOnline, // 保证金
        isHasBond: isHasBond, // 是否拥有保证金银行
        BOND_BANKS: [], // 保证金银行
        MARGIN_AMOUNT_UNIT: "元", // 投标保证金单位
        TRADE_CENTER: { Name: "", Value: "" }, // 交易中心
        TECHNICAL_DOCUMENT: TECHNICAL_DOCUMENT, // 技术文件
        PRE_PERFORM_PRICE_MONEY: PRE_PERFORM_PRICE_MONEY, // 履约保证金金额前缀
        PERFORM_PRICE_MONEY_UNIT: PERFORM_PRICE_MONEY_UNIT, // 履约保证金金额单位
        MARGIN_PAY_TYPE: [],
        //20240501(rd:http://192.168.112.99:8080/redmine/issues/39726 信用分的修改)
        Project_Version: 20240501,
      };
      for (let key in defaultFrom) {
        form[key] = defaultFrom[key];
      }
      /*国资交易平台名称和地址*/
      if (params.regionId == "x60004") {
        form.TRADING_PLATFORM = "福建省国资采购平台";
        form.TRADING_PLATFORM_ADDRESS = "https://ygcg.fjcqjy.com/";
        form.NOTICE_MEDIA3 = "福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）";
        /*勘察设计为NOTICE_MEDIA4*/
        // form.NOTICE_MEDIA4='福建省国资采购平台（网址：https://ygcg.fjcqjy.com/）'
      }
      if (params.regionId == "x60005") {
        //场外福清
        form.TRADING_PLATFORM = "随行易交易（福清）公共资源交易平台";
        form.TRADING_PLATFORM_ADDRESS = "www.fq5191.com";
        form.TRADE_CENTER_SELECT = "场外福清市";
      }
      if (params.regionId == "x60010") {
        //场外龙岩
        form.TRADING_PLATFORM = "易交易（龙岩）公共资源交易平台";
        form.TRADING_PLATFORM_ADDRESS = "http://www.lyyjy.com/";
        form.TRADE_CENTER_SELECT = "场外龙岩市";
      }

      // console.log(form, defaultFrom);
    },
  },
};
